import { IncomingMessage } from 'http';

import Cookies from 'js-cookie';

import { asNetworkAware } from '../../utils/network-error';
import { fechFromBPartsApi } from '../utils';

export const translateSlugs = (
  {
    lang_origin,
    lang_trans,
    slugs,
    csrftoken,
  }: {
    lang_origin: string;
    lang_trans: string | null;
    slugs: Array<{
      slug_type: 'category' | 'part' | 'product';
      slug_origin: string;
    }>;
    csrftoken?: string;
  },
  req?: IncomingMessage
): Promise<
  | {
      lang_origin: string;
      lang_trans: string;
      slugs: Array<{
        slug_type: 'category' | 'part' | 'product';
        slug_origin: string;
      }>;
    }
  | { value: string }
> => {
  const endpoint = `/${lang_origin}/shop/slugs_trans`;

  // Só o `fetch` vai dentro do `asNetworkAware`. A leitura do payload e o
  // `throw json` ficam de FORA de propósito: uma resposta inesperada continua a
  // ser erro nosso, e só a rejeição do próprio pedido é marcada como rede.
  //
  // Este pedido é abortado com frequência por desenho: quem muda o país no
  // modal de settings provoca um `window.location.replace` (ver
  // `utils/set-new-shipping-location`), e o pedido morre com o documento. Sem
  // esta marcação a rejeição chegava ao Sentry como `TypeError: Load failed`.
  return asNetworkAware(
    `POST ${endpoint}`,
    fechFromBPartsApi<Response>(endpoint, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        ...(!!req ? (req?.headers as HeadersInit) : {}),
        'Content-Type': 'application/json',
        cookie: '',
        'X-CSRFToken': csrftoken ?? Cookies.get('csrftoken') ?? '',
      } as HeadersInit),
      body: JSON.stringify({ lang_origin, lang_trans, slugs }),
    })
  ).then(async (value) => {
    const json = await value.json();

    if (value.status >= 400 && value.status < 600) {
      throw json;
    }

    return json;
  });
};
